import { render, staticRenderFns } from "./ChartRecebidasPorTipologia.vue?vue&type=template&id=f9a87152&"
import script from "./ChartRecebidasPorTipologia.vue?vue&type=script&lang=js&"
export * from "./ChartRecebidasPorTipologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports